import React from 'react';

// Single skeleton card — portrait ratio
export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-thumb skeleton-pulse" />
      <div className="skeleton-title skeleton-pulse" />
    </div>
  );
}

// Single skeleton wide card — landscape ratio
export function SkeletonWideCard() {
  return (
    <div className="skeleton-wide-card">
      <div className="skeleton-wide-thumb skeleton-pulse" />
      <div className="skeleton-title skeleton-pulse" style={{ width: '70%' }} />
    </div>
  );
}

// A full content row skeleton
export function SkeletonRow({ wide = false, count = 6 }) {
  return (
    <div className="skeleton-row">
      <div className="skeleton-row-title skeleton-pulse" />
      <div className="skeleton-row-cards">
        {Array.from({ length: count }).map((_, i) =>
          wide ? <SkeletonWideCard key={i} /> : <SkeletonCard key={i} />
        )}
      </div>
    </div>
  );
}

// Full home page skeleton — banner + 3 rows
export function HomeSkeleton() {
  return (
    <div className="skeleton-home">
      <div className="skeleton-hero skeleton-pulse" />
      <div style={{ padding: '0 4vw' }}>
        <SkeletonRow count={6} />
        <SkeletonRow count={6} wide />
        <SkeletonRow count={6} />
      </div>
    </div>
  );
}

// Grid skeleton for movies page
export function GridSkeleton({ count = 12 }) {
  return (
    <div className="skeleton-grid">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-grid-card">
          <div className="skeleton-grid-thumb skeleton-pulse" />
          <div className="skeleton-title skeleton-pulse" style={{ width: '80%', margin: '8px 0 4px' }} />
          <div className="skeleton-title skeleton-pulse" style={{ width: '40%', height: 10 }} />
        </div>
      ))}
    </div>
  );
}
